import { BrowserGlobalRef } from '../global/registry-global';
import { isRealValue } from './helpers';

export const isRegistryProd = (): boolean => {
  const {nativeGlobal: {env}} = new BrowserGlobalRef();

  return isRealValue(env) && ['prod', 'staging', 'sb', 'qa'].includes(env);
};
